<div class="transfer-form-card" [formGroup]="formGroup">

  <section class="block-section">
    <usb-request-header
      [formGroup]="formGroup"
      [selectedFile]="selectedFile"
      [selectedClient]="selectedClient"
      [availablePax]="availablePax"
      [loadingFiles]="loadingFiles"
      [loadingPax]="loadingPax"
      [loadingCountries]="loadingCountries"
      [showNewFileNameInput]="showNewFileNameInput"
      [showNewClientInput]="showNewClientInput"
      [existingFiles]="existingFiles"
      [countriesData]="countriesData"
      [newFilePassenger]="newFilePassenger"
      [newFilePassengerError]="newFilePassengerError"
      [newFilePhoneCode]="newFilePhoneCode"
      [newFilePhoneCodeError]="newFilePhoneCodeError"
      [newFilePhone]="newFilePhone"
      [newFilePhoneError]="newFilePhoneError"
      [newFileEmail]="newFileEmail"
      [newFileEmailError]="newFileEmailError"
      [phoneCodeSelected]="phoneCodeSelected"
      [selectedFileId]="selectedFileId"
      [selectedClientId]="selectedClientId"
      [edit]="edit"
      [requiredFieldMessage]="requiredFieldMessage"
      [getFileLabel]="getFileLabel"
      [getClientLabel]="getClientLabel"
      [getClientsForSelectedFile]="getClientsForSelectedFile"
      [isNuevoFileValid]="isNuevoFileValid"
      [blockInvalidKeys]="blockInvalidKeys"
      (fileChange)="fileChange.emit($event)"
      (fileSearchInput)="fileSearchInput.emit($event)"
      (clearSelectedFile)="clearSelectedFile.emit()"
      (clientChange)="clientChange.emit($event)"
      (paxChange)="paxChange.emit($event)"
      (passengerIdChange)="passengerIdChange.emit($event)"
      (passengerFirstNameChange)="passengerFirstNameChange.emit($event)"
      (passengerLastNameChange)="passengerLastNameChange.emit($event)"
      (requestTypeChange)="requestTypeChange.emit($event)"
      (newFileToggle)="newFileToggle.emit()"
      (newClientToggle)="newClientToggle.emit()"
      (newFileSubmit)="newFileSubmit.emit()"
      (newClientSubmit)="newClientSubmit.emit($event)"
      (newFilePassengerInput)="newFilePassengerInput.emit($event)"
      (newFilePhoneCodeInput)="newFilePhoneCodeInput.emit($event)"
      (newFileCountrySelected)="newFileCountrySelected.emit($event)"
      (newFilePhoneInput)="newFilePhoneInput.emit($event)"
      (newFileEmailInput)="newFileEmailInput.emit($event)"
      (countrySelected)="countrySelected.emit($event)"
      (phoneCodeInput)="phoneCodeInput.emit($event)"
      (clientFirstNameChange)="clientFirstNameChange.emit($event)"
      (clientLastNameChange)="clientLastNameChange.emit($event)"
      (clientEmailChange)="clientEmailChange.emit($event)"
      (clientPhoneChange)="clientPhoneChange.emit($event)"
    ></usb-request-header>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">2</span>
      <div class="block-header-text">
        <p class="block-title">Datos del traslado</p>
        <p class="block-caption">Origen, destino y horarios del servicio.</p>
      </div>
    </header>

    <div class="form-grid-2">
      <div class="form-field-with-icon">
        <label class="field-label">Origen <span class="required-marker">*</span></label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
          </span>
          <input type="text" class="field-input" placeholder="Aeropuerto, hotel, puerto o dirección de origen"
                 formControlName="origin" list="transfer-locations" />
        </div>
        <p class="field-error" *ngIf="formGroup.get('origin')?.hasError('required') && formGroup.get('origin')?.touched">
          Ingresá el origen del traslado.
        </p>
      </div>
      <div class="form-field-with-icon">
        <label class="field-label">Destino <span class="required-marker">*</span></label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
          </span>
          <input type="text" class="field-input" placeholder="Aeropuerto, hotel, puerto o dirección de destino"
                 formControlName="destination" list="transfer-locations" />
        </div>
        <p class="field-error" *ngIf="formGroup.get('destination')?.hasError('required') && formGroup.get('destination')?.touched">
          Ingresá el destino del traslado.
        </p>
      </div>
    </div>
    <datalist id="transfer-locations">
      <option value="Aeropuerto Internacional de Ezeiza"></option>
      <option value="Aeroparque Jorge Newbery"></option>
      <option value="Terminal de Cruceros Benito Quinquela Martín"></option>
      <option value="Terminal de Ómnibus de Retiro"></option>
    </datalist>

    <div class="form-grid-2">
      <div>
        <label class="field-label">Fecha de recogida <span class="required-marker">*</span></label>
        <input type="text" class="field-input" placeholder="Seleccioná la fecha"
               formControlName="pickupDate" (click)="openDatePicker('pickupDate')" readonly />
        <p class="field-error" *ngIf="formGroup.get('pickupDate')?.hasError('required') && formGroup.get('pickupDate')?.touched">
          Seleccioná la fecha de recogida.
        </p>
      </div>
      <div class="form-field-with-icon">
        <label class="field-label">Hora de recogida <span class="required-marker">*</span></label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
          </span>
          <input type="time" class="field-input" formControlName="pickupTime" />
        </div>
        <p class="field-error" *ngIf="formGroup.get('pickupTime')?.hasError('required') && formGroup.get('pickupTime')?.touched">
          Seleccioná la hora de recogida.
        </p>
      </div>
    </div>

    <div class="form-grid-2">
      <div>
        <label class="field-label">Fecha de vuelta</label>
        <input type="text" class="field-input" placeholder="Seleccioná la fecha"
               formControlName="returnDate" (click)="openDatePicker('returnDate')" readonly />
        <p class="field-error" *ngIf="formGroup.get('returnDate')?.invalid && formGroup.get('returnDate')?.touched">
          {{ getReturnDateError() }}
        </p>
      </div>
      <div class="form-field-with-icon">
        <label class="field-label">Hora de vuelta</label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
          </span>
          <input type="time" class="field-input" formControlName="returnTime" />
        </div>
        <p class="field-error" *ngIf="formGroup.get('returnTime')?.invalid && formGroup.get('returnTime')?.touched">
          {{ getReturnTimeError() }}
        </p>
      </div>
    </div>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">3</span>
      <div class="block-header-text">
        <p class="block-title">Pasajeros</p>
        <p class="block-caption">Cantidad de pasajeros del traslado.</p>
      </div>
    </header>

    <div class="form-grid-3">
      <div class="form-field-with-icon">
        <label class="field-label">Adultos <span class="required-marker">*</span></label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
          </span>
          <input type="number" min="1" class="field-input" placeholder="1" formControlName="adults" />
        </div>
        <p class="field-error" *ngIf="formGroup.get('adults')?.hasError('required') && formGroup.get('adults')?.touched">
          Ingresá al menos un adulto.
        </p>
      </div>
      <div>
        <label class="field-label">Niños</label>
        <input type="number" min="0" class="field-input" placeholder="0" formControlName="children"
               (change)="onChildrenChange($any($event.target).value)" />
      </div>
      <div>
        <label class="field-label">Total de pasajeros</label>
        <input type="text" class="field-input" [value]="totalPassengers" readonly />
      </div>
    </div>

    <div *ngIf="childrenCount > 0" class="mt-3">
      <div class="form-grid-4">
        <div *ngFor="let age of childAgesArray.controls; let i = index" [formGroup]="childAgesArray.controls[i]">
          <label class="field-label">Edad del niño {{ i + 1 }} <span class="required-marker">*</span></label>
          <select class="field-input"
                  (change)="onChildAgeChange(i, $any($event.target).value)">
            <option value="">Seleccioná edad</option>
            <option *ngFor="let a of ageOptions" [value]="a">{{ a }} {{ a === 1 ? 'año' : 'años' }}</option>
          </select>
        </div>
      </div>
      <p class="field-error" *ngIf="formGroup.get('childAges')?.invalid && formGroup.get('childAges')?.touched">
        Seleccioná la edad de cada niño.
      </p>
    </div>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">4</span>
      <div class="block-header-text">
        <p class="block-title">Preferencias</p>
        <p class="block-caption">Detalles del servicio.</p>
      </div>
    </header>

    <div class="form-grid-2">
      <div class="transfer-option-card">
        <div class="transfer-option-card__header">
          <span class="transfer-option-card__icon">user</span>
          <h4 class="transfer-option-card__title">Modalidad</h4>
        </div>
        <ul class="transfer-option-card__options">
          <li class="transfer-option-card__option" *ngFor="let opt of modalityOptions">
            <label>
              <span>{{ opt }}</span>
              <input type="radio" name="modality" [checked]="isModalitySelected(opt)" (change)="setModality(opt)" />
            </label>
          </li>
        </ul>
      </div>

      <div class="transfer-option-card">
        <div class="transfer-option-card__header">
          <span class="transfer-option-card__icon">grid</span>
          <h4 class="transfer-option-card__title">Categoría</h4>
        </div>
        <ul class="transfer-option-card__options">
          <li class="transfer-option-card__option" *ngFor="let opt of categoryOptions">
            <label>
              <span>{{ opt }}</span>
              <input type="radio" name="category" [checked]="isCategorySelected(opt)" (change)="setCategory(opt)" />
            </label>
          </li>
        </ul>
      </div>
    </div>

    <div class="transfer-option-card">
      <div class="transfer-option-card__header">
        <span class="transfer-option-card__icon">car</span>
        <h4 class="transfer-option-card__title">Tipo de vehículo</h4>
      </div>
      <div class="transfer-option-card__split-columns">
        <ul class="transfer-option-card__options">
          <li class="transfer-option-card__option" *ngFor="let opt of vehicleOptionsFirstHalf">
            <label>
              <span>{{ opt }}</span>
              <input type="checkbox" [checked]="isVehicleSelected(opt)" (change)="toggleVehicle(opt)" />
            </label>
          </li>
        </ul>
        <ul class="transfer-option-card__options">
          <li class="transfer-option-card__option" *ngFor="let opt of vehicleOptionsSecondHalf">
            <label>
              <span>{{ opt }}</span>
              <input type="checkbox" [checked]="isVehicleSelected(opt)" (change)="toggleVehicle(opt)" />
            </label>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">5</span>
      <div class="block-header-text">
        <p class="block-title">Comentarios u observaciones</p>
        <p class="block-caption">Agregá información adicional para tu equipo.</p>
      </div>
    </header>
    <textarea class="field-input" rows="5" maxlength="1000"
              placeholder="Escribí cualquier información adicional que debamos tener en cuenta."
              formControlName="comments"></textarea>
  </section>

  <div class="form-footer">
    <p class="form-footer__caption">Podés incluir diferentes servicios dentro de una misma solicitud.</p>
    <div class="form-footer__actions">
      <button type="button" class="btn-clear" (click)="confirmClear()">Borrar</button>
      <button type="button" class="btn-submit"
              [disabled]="!requestReady || !formGroup.valid"
              (click)="onSubmit()">Enviar</button>
    </div>
  </div>

  <div *ngIf="showClearDialog" class="confirm-overlay">
    <div class="confirm-dialog">
      <h4>¿Querés borrar los datos cargados en esta cotización?</h4>
      <div class="confirm-dialog__actions">
        <button type="button" class="btn-cancel" (click)="cancelClear()">Cancelar</button>
        <button type="button" class="btn-danger" (click)="confirmClearAction()">Sí, borrar</button>
      </div>
    </div>
  </div>
</div>
